import { render, staticRenderFns } from "./major-list.vue?vue&type=template&id=74df77e4&scoped=true"
import script from "./major-list.vue?vue&type=script&lang=js"
export * from "./major-list.vue?vue&type=script&lang=js"
import style0 from "./major-list.vue?vue&type=style&index=0&id=74df77e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df77e4",
  null
  
)

export default component.exports